import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initNewsSlider() {
    const sliderElement = document.querySelector('.js-news-slider');
    
    if (!sliderElement) return;

    new Swiper(sliderElement, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.2,
        spaceBetween: 13,
        slidesOffsetAfter: 24,
        loop: false,
        pagination: {
            el: '.swiper-newsblock-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.c_swiper-newsblock-next',
            prevEl: '.c_swiper-newsblock-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 27,
            },
        },
    });
}

